import React from 'react'
import { Formik, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import { Form as FormUi, Container, Button, Label, Modal, Checkbox,Divider, Header, Radio, Dropdown } from 'semantic-ui-react';
import Axios from 'axios';

import { MyInput, MyTextArea } from '../../formikInput/input';
import APP_CONSTANTS from '../../../config/constants';
import cogoToast from 'cogo-toast';
import { AllRegex } from '../../../utils/validation';

import {
    FIELD_IS_REQUIRED, INVALID_BANK_ACC_NUMBER,
    INVALID_BANK_IFSC, INVALID_GST_NO, INVALID_NAME,
    INVALID_PAN_NO, INVALID_PINCODE
} from '../../../config/const';
import MyCity from '../../dropdowns/citySearchDropdown';
import MyState from '../../dropdowns/stateSearchDropdown';
import { DateData } from '../../formikInput/date';
import UpdateAxios from '../../axiosComponent/update';
import { LOCAL_STORAGE } from '../../../config/const';
import {vendor_branch} from './vendorConstants'
const AddVendorBranchModal = ({ handleCloseEdit, addVendorBranch, branch, vendorId,editData, ...props }) => {

    let currentYear = new Date().getFullYear()
    let currentMonth = new Date().getMonth()
    let fromYear =currentMonth <4?currentYear -1:currentYear
    let toYear = fromYear+1
    let max_date = new Date(`${currentYear}-12-31`)

    const initialValues = {
        vendorBranchId : editData?.vendorBranchId || null,
        vendorBranchName: editData?.vendorBranchName || '',
        vendorBranchStateId: editData?.vendorBranchStateId || '',
        vendorBranchPAN: editData?.vendorBranchPAN || '',
        vendorBranchGST: editData?.vendorBranchGST?.trim() || '',
        vendorBranchCity: editData?.vendorBranchCityId || '',
        vendorBranchPincode: editData?.vendorBranchPincode || '',
        vendorBranchBankName: editData?.vendorBranchBankName || '',
        vendorBranchBankAccountHolder: editData?.vendorBranchBankAccountHolder || '',
        vendorBranchAccountNumber: editData?.vendorBranchAccountNumber || '',
        vendorBranchBankIFSC: editData?.vendorBranchBankIFSC || '',
        vendorBranchAddress: editData?.vendorBranchAddress || '',
        isGSTApplicable : editData?.isGSTApplicable===1 ? true : false ,
        gstChargeMechanism : editData?.gstChargeMechanism?.trim() || '',
        validityStartDate :editData ?(editData?.validityStartDate && editData?.validityStartDate !== "0000-00-00" ? new Date(editData.validityStartDate) : "") :  new Date(`${fromYear}-04-01 05:35:32`),
        validityEndDate : editData ?(editData?.validatityEndDate && editData?.validatityEndDate !== "0000-00-00"? new Date(editData.validatityEndDate) : "") : new Date(`${toYear}-03-31 05:35:32`),
        vendorId: vendorId
    };

    const validateSchema = yup.object().shape({
        vendorBranchName: yup.string().required(FIELD_IS_REQUIRED),
        vendorBranchStateId: yup.number().required(FIELD_IS_REQUIRED),
        vendorBranchPAN: yup.string().matches(AllRegex.PANIN, INVALID_PAN_NO).optional().nullable(),
        vendorBranchCity: yup.string().required(FIELD_IS_REQUIRED),
        vendorBranchPincode: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Pincode, INVALID_PINCODE),
        vendorBranchBankName: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_NAME),
        vendorBranchBankAccountHolder : yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_NAME),
        vendorBranchAccountNumber: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.BankAccNumber, INVALID_BANK_ACC_NUMBER),
        vendorBranchBankIFSC: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.BankIFSCcode, INVALID_BANK_IFSC),
        vendorBranchGST: yup.string().when('isGSTApplicable', {
            is: (isGSTApplicable) => {
                return isGSTApplicable && isGSTApplicable == true ? true : false
            },
            then: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.GSTIN, INVALID_GST_NO),
            otherwise: yup.string().optional()
        }),
        vendorBranchAddress: yup.string().optional().nullable(),
    });
    const chargeMechanismOption = [{
        id:1,
        text:"Forward Charging Mechanism",
        value:"FCM",
        key:1
    },{
        id:2,
        text:"Reverse Charging Mechanism",
        value:"RCM",
        key:2
    }]
    const onSubmit = (values, onSubmitProps) => {
       
        const branchData = {
            customerNo: LOCAL_STORAGE.customerNo,
            customerNumber: LOCAL_STORAGE.customerNo,
            customer_no: LOCAL_STORAGE.customerNo,
            userId: LOCAL_STORAGE.userId,
            user_id: LOCAL_STORAGE.userId,
            ...values
        }
     if(values.vendorBranchId){ 
        if(values.gstChargeMechanism){
            if(!values.validityStartDate){
                values.validityStartDate = new Date(`04-01-${fromYear} 05:35:32`)
            }
            if(!values.validityEndDate){
                values.validityEndDate = new Date(`03-31-${toYear} 05:35:32`)
            }
        }
        UpdateAxios({
            url: `vendorBranch`,
            payload: { ...values },
            uniqueId: values.vendorBranchId
        }).then((response)=>{
            if(response?.data?.status==200){
                cogoToast.success(response.data.message, { position: 'top-right' })
                setTimeout(() => { window.location.reload() }, 1000)
            }else{
                cogoToast.error(response?.data?.message, { position: 'top-right' })
            }
        }).catch((err)=>{
            console.log(err);
        })
     }else{
        Axios.put(`${APP_CONSTANTS.BASE_URL}masters/vendorBranch/${vendorId}`, branchData, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('apiToken')
            }
        }).then((response => {
            if(response?.data?.status ==200){
                cogoToast.success(response.data.message, { position: 'top-right' })
                setTimeout(() => { window.location.reload() }, 1000)
            }else{
                cogoToast.error(response.data.message, { position: 'top-right' })
            }
        }))
            .catch(error => {
                console.log(error)
                onSubmitProps.setSubmitting(false);
            })
     }
        

    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validateSchema}
                onSubmit={onSubmit}
            >
                {({ values, isSubmitting, errors, touched, handleSubmit, setFieldValue }) => (
                    <>

                        <Modal.Content className="scrolling">
                            <Container>
                                <div className="ui form tiny">
                                    <FormUi.Group>
                                        <FormUi.Field width="7">
                                            <label className="labelName p-bold-600">{vendor_branch?.fields?.branch?.title||"Branch"} {" "}<b className="w3-text-red"> *</b></label>
                                            <Fieldmik name="vendorBranchName" component={MyInput} error={values.vendorBranchName ? false : true} placeholder={vendor_branch?.fields?.branch?.placeholder||"Enter Branch Name"} maxLength={50} />
                                            {touched.vendorBranchName && errors.vendorBranchName ? <Label size="mini" prompt pointing>{errors.vendorBranchName}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="2"/>
                                        <FormUi.Field width="7">
                                            <label className="labelName p-bold-600">{vendor_branch?.fields?.state?.title||"State"} {" "}<b className="w3-text-red"> *</b></label>
                                            <Fieldmik name="vendorBranchStateId" className="p-placeholder" component={MyState} error={values.vendorBranchStateId ? false : true} placeholder={editData?.vendorBranchState||vendor_branch?.fields?.state?.placeholder||"Enter State"} />
                                            {touched.vendorBranchStateId && errors.vendorBranchStateId ? <Label size="mini" prompt pointing>{errors.vendorBranchStateId}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                    <FormUi.Field width="7">
                                            <label className="labelName p-bold-600">{vendor_branch?.fields?.city?.title||"City"} {" "}<b className="w3-text-red"> *</b></label>
                                            <Fieldmik name="vendorBranchCity" className="p-placeholder" citynameValue={true} component={MyCity}error={values.vendorBranchCity ? false : true} placeholder={values?.vendorBranchCity ||vendor_branch?.fields?.city?.placeholder || "Select City"} />
                                            {touched.vendorBranchCity && errors.vendorBranchCity ? <Label size="mini" prompt pointing>{errors.vendorBranchCity}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="2"/>
                                        <FormUi.Field width="7">
                                            <label className="labelName p-bold-600">{vendor_branch?.fields?.pincode?.title||"Pincode"} {" "}<b className="w3-text-red"> *</b></label>
                                            <Fieldmik name="vendorBranchPincode" component={MyInput} error={values.vendorBranchPincode ? false : true} placeholder={vendor_branch?.fields?.pincode?.placeholder||"Enter Pincode"} maxLength={6} />
                                            {touched.vendorBranchPincode && errors.vendorBranchPincode ? <Label size="mini" prompt pointing>{errors.vendorBranchPincode}</Label> : ''}
                                        </FormUi.Field>
                                        
                                    </FormUi.Group>

                                    <FormUi.Group>
                                        <FormUi.Field width="7">
                                            <label className="labelName p-bold-600">{vendor_branch?.fields?.pan_no?.title||"Pan Number"}</label>
                                            <Fieldmik name="vendorBranchPAN" component={MyInput} error={values.vendorBranchPAN ? false : true} placeholder={vendor_branch?.fields?.pan_no?.placeholder||"Enter PAN Number"} maxLength={30} />
                                            {touched.vendorBranchPAN && errors.vendorBranchPAN ? <Label size="mini" prompt pointing>{errors.vendorBranchPAN}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="2"/>
                                        <FormUi.Field width="7">
                                        <label className="labelName p-bold-600">{vendor_branch?.fields?.address?.title||"Address"}</label>
                                        <Fieldmik name="vendorBranchAddress" component={MyTextArea} error={values.vendorBranchAddress ? false : true} placeholder={vendor_branch?.fields?.address?.placeholder||"Enter Address"} maxLength={200} />
                                        {touched.vendorBranchAddress && errors.vendorBranchAddress ? <Label size="mini" prompt pointing>{errors.vendorBranchAddress}</Label> : ''}
                                    </FormUi.Field>
                                    </FormUi.Group>

                                    <Divider horizontal>
                                        <Header as='h4'>
                                        {vendor_branch?.titles?.gst_title||"GST_Details"}
                                        </Header>
                                    </Divider>

                                    <FormUi.Group>
                                        <FormUi.Field width="3">
                                            <label className="labelName p-bold-600">{vendor_branch?.fields?.is_gst_applicable?.title||"Is GST Applicable?"}</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="2">
                                            <Radio label="No" name='isGSTApplicable' value='No'
                                            checked={values.isGSTApplicable === false} onChange={() => { 
                                            setFieldValue("isGSTApplicable", !values.isGSTApplicable)
                                            setFieldValue("vendorBranchGST", "") 
                                            setFieldValue("gstChargeMechanism", "")
                                            setFieldValue("validityStartDate", new Date(`${fromYear}-04-01 05:35:32`)) 
                                            setFieldValue("validityEndDate", new Date(`${toYear}-03-31 05:35:32`)) 
                                            }} />
                                            </FormUi.Field>
                                            <FormUi.Field width="2">
                                            <Radio label="Yes" name='isGSTApplicable' value='Yes'
                                            checked={values.isGSTApplicable === true} onChange={() => { setFieldValue("isGSTApplicable", !values.isGSTApplicable)}} />
                                            </FormUi.Field>
                                        
                                            <FormUi.Field width="2"/>
                                            {
                                                values.isGSTApplicable ?
                                                    <FormUi.Field width="7">
                                                        <label className="labelName p-bold-600">{vendor_branch?.fields?.gst_no?.title||"GST Number"} <b className="w3-text-red"> *</b></label>
                                                        <Fieldmik name="vendorBranchGST" component={MyInput} error={values.vendorBranchGST ? false : true} placeholder={vendor_branch?.fields?.gst_no?.placeholder||"Enter GST Number"} />
                                                        {touched.vendorBranchGST && errors.vendorBranchGST ? <Label size="mini" prompt pointing>{errors.vendorBranchGST}</Label> : ''}
                                                    </FormUi.Field> : null
                                            }
                                
                                    </FormUi.Group>

                                    {
                        values.isGSTApplicable ?
                            <>
                             <FormUi.Group>
                                    <FormUi.Field width="7">
                                        <label>{vendor_branch?.fields?.charge_mechanism?.title||"Charge Mechanism"}</label>
                                        <Dropdown
                                            name="gstChargeMechanism"
                                            clearable
                                            style={{ width: "100%", fontWeight: "normal" }}
                                            selection
                                            placeholder={vendor_branch?.fields?.charge_mechanism?.placeholder||"Select Charge Mechanism"}
                                            value={values.gstChargeMechanism}
                                            options={chargeMechanismOption}
                                            onChange={(name, data) => {
                                                setFieldValue("gstChargeMechanism", data.value);
                                            }}
                                        />
                                    </FormUi.Field>
                                </FormUi.Group>
                                <FormUi.Group>
                                    <FormUi.Field width="7">
                                        <label>{vendor_branch?.fields?.start_date?.title||"Validity Start Date"}</label>
                                        <DateData
                                            name="validityStartDate"
                                            autoComplete="off"
                                            maxDate=  {new Date(values.validityEndDate).getFullYear() == currentYear ?values.validityEndDate : max_date}
                                            value = {values.validityStartDate}
                                            customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                        />
                                         {touched.validityStartDate && errors.validityStartDate ? <small className="text-danger">{errors.validityStartDate}</small> : ''}
                                    </FormUi.Field>
                                    <FormUi.Field width="2" />
                                    <FormUi.Field width="7">
                                        <label>{vendor_branch?.fields?.end_date?.title||"Validity End Date"}</label>
                                        <DateData
                                            name="validityEndDate"
                                            autoComplete="off"
                                            minDate={values.validityStartDate}
                                            value = {values.validityStartDate == null ?values.validityEndDate="" :values.validityEndDate}
                                            customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                        />
                                         {touched.validityEndDate && errors.validityEndDate ? <small className="text-danger">{errors.validityEndDate}</small> : ''}
                                    </FormUi.Field>
                                </FormUi.Group>
                            </> : null
                    }

                                    <Divider horizontal>
                                        <Header as='h4'>
                                        {vendor_branch?.titles?.bank_title||"Bank Details"}
                                        </Header>
                                    </Divider>
                                    <FormUi.Group>
                                        <FormUi.Field width="7">
                                            <label className="labelName p-bold-600">{vendor_branch?.fields?.bank_name?.title||"Bank Name"} <b className="w3-text-red"> *</b></label>
                                            <Fieldmik name="vendorBranchBankName" component={MyInput} error={values.vendorBranchBankName ? false : true} placeholder={vendor_branch?.fields?.bank_name?.placeholder||"Enter Bank Name"} maxLength={50}/>
                                            {touched.vendorBranchBankName && errors.vendorBranchBankName ? <Label size="mini" prompt pointing>{errors.vendorBranchBankName}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="2"/>
                                        <FormUi.Field width="7">
                                            <label className="labelName p-bold-600">{vendor_branch?.fields?.account_holder?.title||"Account Holder Name"} <b className="w3-text-red"> *</b></label>
                                            <Fieldmik name="vendorBranchBankAccountHolder" component={MyInput} error={values.vendorBranchBankAccountHolder ? false : true} placeholder={vendor_branch?.fields?.account_holder?.placeholder||"Enter A/C Holder Name"} maxLength={50} />
                                            {touched.vendorBranchBankAccountHolder && errors.vendorBranchBankAccountHolder ? <Label size="mini" prompt pointing>{errors.vendorBranchBankAccountHolder}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    <FormUi.Group>
                                        <FormUi.Field width="7">
                                            <label className="labelName p-bold-600">{vendor_branch?.fields?.account_no?.title||"Account Number"} <b className="w3-text-red"> *</b></label>
                                            <Fieldmik name="vendorBranchAccountNumber" component={MyInput} error={values.vendorBranchAccountNumber ? false : true} placeholder={vendor_branch?.fields?.account_no?.placeholder||"Enter A/C Number"} maxLength={50}/>
                                            {touched.vendorBranchAccountNumber && errors.vendorBranchAccountNumber ? <Label size="mini" prompt pointing>{errors.vendorBranchAccountNumber}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="2"/>
                                        <FormUi.Field width="7">
                                            <label className="labelName p-bold-600">{vendor_branch?.fields?.ifsc?.title||"IFSC Code"} <b className="w3-text-red"> *</b></label>
                                            <Fieldmik name="vendorBranchBankIFSC" component={MyInput} error={values.ifscCode ? false : true} placeholder={vendor_branch?.fields?.ifsc?.placeholder||"Enter IFSC Code"} maxLength={20}/>
                                            {touched.vendorBranchBankIFSC && errors.vendorBranchBankIFSC ? <Label size="mini" prompt pointing>{errors.vendorBranchBankIFSC}</Label> : ''}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                    
                                </div>
                            </Container>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button onClick={handleCloseEdit} size="mini">{vendor_branch?.buttons?.cancel||"Cancel"}</Button>
                            <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} size="mini" primary>{vendor_branch?.buttons?.submit||"Submit"}</Button>
                        </Modal.Actions>
                    </>
                )}
            </Formik>
        </>
    )
}

export default AddVendorBranchModal
